/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.QuickbooksDesktop{

    import IConnectionListItem = Meevo.Plugins.QuickbooksDesktop.IConnectionListItem;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    interface IQuickbooksDesktopController{
        currentStep: QuickbooksDesktopTabsEnum;
        closeContext: () => void;
        onChangeCurrentStep: (step: QuickbooksDesktopTabsEnum) => ng.IPromise<any>;
        connectionList: Array<IConnectionListItem>;  
        getConnections: () => ng.IPromise<Array<IConnectionListItem>>;
        onInit: () => void;
        latestConnectionId: Guid;
    }

    export class QuickbooksDesktopController implements IQuickbooksDesktopController {
        public latestConnectionId: Guid;
        private _currentStep = QuickbooksDesktopTabsEnum.Main;
        public connectionList: IConnectionListItem[];

        static $inject = [
            "$rootScope",
            "$scope",
            "$state",
            "meevo.components.busy.BusyService",
            "meevo.components.common.DataService",
            'meevo.plugins.quickbooksDesktop.QuickbooksDesktopApi',
            '$q',
        ];

        constructor(
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected apiService: IQuickbooksDesktopApi,
            protected $q: angular.IQService
        ) {
            this.onInit();
        }

        /**
         * Initialize QB Desktop integration Plugin
         * */
        onInit(): void {
            this.busyService.start();
            this.getConnections().then((connectionList: Array <IConnectionListItem>) => {
                    if (connectionList.length) this.currentStep = QuickbooksDesktopTabsEnum.Sync;
                })
                .finally(() => this.busyService.stop());
        }

        /**
         * Handler of step changing
         * @param {QuickbooksDesktopTabsEnum} step
         */
        onChangeCurrentStep(step: QuickbooksDesktopTabsEnum): ng.IPromise<any> {
            this.currentStep = step;
            return this.$q.resolve();
        }

        /**
         * Get List of existing connections
         * @returns {ng.IPromise<Array<IConnectionListItem>>}
         * */
        getConnections(): ng.IPromise<Array<IConnectionListItem>> {
            return this.apiService.getConnections().then((data: Array<IConnectionListItem> | any) => {
                this.connectionList = data;
                return this.connectionList;
            });
        }

        setLatestConnectionId(connectionId: Guid) {
            this.latestConnectionId = connectionId;
        }

        selectTab(type: string): void {
            //this.getConnections();

            this.$scope.$broadcast(type, { latestConnectionId: this.latestConnectionId });
        }

        /**
         * Close current tab
         * */
        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        }

        get quickbooksDesktopTabsEnum() {
            return QuickbooksDesktopTabsEnum;
        }

        get currentStep(): QuickbooksDesktopTabsEnum {
            return this._currentStep;
        }

        get securityAccessEnum() {
            return SecurityAccessEnum;
        }

        set currentStep(value: QuickbooksDesktopTabsEnum) {
            if (this._currentStep === QuickbooksDesktopTabsEnum.Sync) this.$scope.$broadcast('resetData');
            this._currentStep = value;
        }

    }

    angular.module('meevo.plugins.quickbooksDesktop')
        .controller('meevo.plugins.quickbooksDesktop.QuickbooksDesktopController', QuickbooksDesktopController);
}
